module.exports = __webpack_public_path__ + "img/ic_footer_social_tiktok.94f69b0d.svg";